<template>
  <base-modal>
    <z-form ref="form">
      <z-form-group class="row">
        <div class="col-4">
          {{ $t('voice.stats.general.filter.voice_stats.trunk.title') }}
        </div>
        <div class="col-8 pl-0 pr-25">
          <z-form-input
            class="filter__item__body"
            :rules="{ required: true }"
            :show_errors="false"
            mode="aggressive"
          >
            <trunks-input-select-trunk v-model="form.trunk_id" :trunks="trunks" />
          </z-form-input>
        </div>
      </z-form-group>
      <z-form-group class="row">
        <div class="col-4">
          {{ $t('shared.component.filter.period') }}
        </div>
        <div class="col-8 pl-0 pr-25">
          <z-form-input class="filter__item__body">
            <date-range-picker
              v-model="form.date"
              :clearable="false"
              :options="options"
              :export="true"
            />
          </z-form-input>
        </div>
      </z-form-group>
    </z-form>
    <template #footer-cancel="{ close }">
      <i-button ref="close" size="large" @click="close()">
        {{ $t('shared.component.button.cancel') }}
      </i-button>
    </template>
    <tooltip
      slot="footer-ok"
      placement="top"
      theme="light"
      class="ml-2"
      style="width: 100%"
      :disabled="!!form.trunk_id"
      :transfer="true"
      :content="$t('shared.component.select.required_trunk')"
    >
      <i-button type="success" size="large" :disabled="!form.trunk_id" @click="exportRequest">
        {{ $t('shared.component.export_report.export_modal') }}
      </i-button>
    </tooltip>
  </base-modal>
</template>

<script>
  import BaseModal from '@shared/components/modal/modal';
  import TrunksInputSelectTrunk from '@voice/components/trunks-input-select-trunk';
  import { initSearchStateByPeriod, parseSearchStateByPeriod } from '@shared/helpers/date_format';
  import { VoiceService } from '@voice/services/VoiceService';

  export default {
    components: {
      BaseModal,
      TrunksInputSelectTrunk
    },
    props: {
      trunks: {
        type: [Array],
        default: () => []
      }
    },

    data() {
      return {
        form: {
          trunk_id: null,
          date: initSearchStateByPeriod()
        },
        options: 2592000000 // 30 day
      };
    },

    created() {
      if (this.trunks?.length) {
        this.form.trunk_id = this.trunks[0]?.id;
      }
    },

    methods: {
      getFormData() {
        const { start, end } = parseSearchStateByPeriod(this.form.date);
        const { trunk_id } = this.form;

        const params = {
          format: 'csv',
          date_from: start,
          date_to: end,
          trunk_id,
          initiator: 'frontend',
        };

        return params;
      },
      exportRequest() {
        const params = this.getFormData();
        this.$refs.form.validate().then((is_valid) => {
          if (is_valid) {
            VoiceService.downloadReport(params)
              .then(() => {
                this.$noty.success(this.$t('shared.component.noty.export_started'));
              })
              .catch((error) => this.$noty.server_error(error));
          }
        });
        this.$refs.close.$el.click();
      }
    }
  };
</script>

<style lang="scss">
  .pr-25 {
    padding-right: 25px !important;
  }
  .filter__item--datepicker .ivu-date-picker {
    width: 100%;
  }
  .z-form-item {
    .main-ip__tooltip {
      .ivu-tooltip {
        position: absolute;
        top: 5px;
        right: -26px;

        &-popper {
          left: -130px !important;
        }

        &-arrow {
          left: 141px !important;
        }

        &-inner {
          width: 150px;
        }

        i {
          font-size: 21px;
        }
      }
    }
  }
</style>
